import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useParams, useNavigate } from "react-router-dom";
import { useAlert } from "react-alert";
import HeaderCreateMission from "../components/create_mission_components/components/HeaderCreateMission";



// Api Calls
import MissionAPI from "../api/api_calls/MissionAPI";

import { MainSection, SectionTitle } from "../components/common_components/Layout";
import HeaderResearcher from "../components/common_components/HeaderResearcher";
import SelectAudienceFormat from "../components/create_mission_components/SelectAudienceFormat";
// import CreateMissionDetails from "../components/create_mission_components/pages/CreateMissionDetails";
import SessionDetails from "../components/create_mission_components/pages/SessionDetails";
import AudienceCreatePage from "../components/create_mission_components/pages/AudienceCreatePage";
import ScreenerReview from "../components/create_mission_components/pages/ScreenerReview";
import SchedulingCreatePage from "../components/create_mission_components/pages/SchedulingCreatePage";
import MissionNameAndDetails from "../components/create_mission_components/pages/MissionNameAndDetails";
import SurveyDetails from "../components/create_mission_components/pages/SurveyDetails";
import SurveyReview from "../components/create_mission_components/pages/SurveyReview";
import Payment from "../components/create_mission_components/pages/Payment";
import PaymentConfirmation from "../components/create_mission_components/pages/PaymentConfirmation";
import CryptoConfirmation from "../components/create_mission_components/pages/CryptoConfirmation";
import InvoiceConfirmation from "../components/create_mission_components/pages/InvoiceConfirmation";
import CreateMissionProgressBar from "../components/create_mission_components/components/CreateMissionProgressBar";



function CreateMission() {

    return (
        <>
            <Routes>
                <Route path="" element={<><HeaderResearcher /><SelectAudienceFormat /></>} />
                <Route path=":missionId/*" element={<CreateMissionContainer />} />
            </Routes>
        </>

    )

}

function CreateMissionContainer(props) {
    // Okay, so in this one, we want to be able to tell the progress bar what function to save. 
    const [missionType, setMissionType] = useState(null);
    const [loadingMissionType, setLoadingMissionType] = useState(true);
    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()


    // Fetch the mission type from the mission id.
    useEffect(() => {
        async function fetchMissionType() {
            const response = await MissionAPI.showIntendedMissionType({ missionId: missionId, handleRedirect: navigate });

            if (response.success) {
                setMissionType(response.mission_type);
                setLoadingMissionType(false);
            } else {
                alert.show(response.error, { type: 'error' })
            }
        }

        fetchMissionType();
    }, [])


    // Lets try calculating the forward button and back button here.
    // This will be based on the mission type and the current page.
    // The progress bar is calculating it on its own - so this is for the outlet pages.
    const interviewPageOrder = ["sessiondetails", "audience", "scheduling", "missionname", "payment", "paymentconfirmation", "cryptoconfirmation"];
    const surveyPageOrder = ["surveydetails", "audience", "survey", "missionname", "payment", "paymentconfirmation", "cryptoconfirmation"];
    const location = useLocation();
    const splitUrl = location.pathname.split("/");
    const currentPage = splitUrl[splitUrl.length - 1];
    const pageOrder = missionType == "interview" ? interviewPageOrder : missionType == "survey" ? surveyPageOrder : null;
    const prefix = "/createmission/" + missionId + "/";
    const index = pageOrder == null ? null : pageOrder.indexOf(currentPage);
    const nextPage = pageOrder == null ? null : index >= 0 && index < pageOrder.length - 1 ? prefix + pageOrder[index + 1] : null;
    const backPage = pageOrder == null ? null : index > 0 ? prefix + pageOrder[index - 1] : "/createmission";

    const [allowedToProgress, setAllowedToProgress] = useState(false);

    useEffect(() => {
        // If currentPage.toLowerCase() is one of sessiondetails or surveydetails, then we
        // set allowedToProgress to false.
        // Otherwise, we set it to true.

        if (currentPage.toLowerCase() == "sessiondetails" || currentPage.toLowerCase() == "surveydetails") {
            setAllowedToProgress(false);
        } else {
            setAllowedToProgress(true);
        }
    }, [currentPage])

    // 
    return (
        <div className="create-mission-container">
            <CreateMissionProgressBar missionType={missionType} loadingMissionType={loadingMissionType} interviewPageOrder={interviewPageOrder} surveyPageOrder={surveyPageOrder} currentPage={currentPage} allowedToProgress={allowedToProgress} />
            <div className="create-mission-placeholder-container">
                <HeaderCreateMission />
                <Routes>
                    <Route path="sessiondetails" element={<SessionDetails missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="surveydetails" element={<SurveyDetails missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="audience" element={<AudienceCreatePage missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="screener" element={<ScreenerReview missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="survey" element={<SurveyReview missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="scheduling" element={<SchedulingCreatePage missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="missionname" element={<MissionNameAndDetails missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="payment" element={<Payment missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="paymentconfirmation" element={<PaymentConfirmation missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="cryptoconfirmation" element={<CryptoConfirmation missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                    <Route path="invoiceconfirmation" element={<InvoiceConfirmation missionType={missionType} loadingMissionType={loadingMissionType} nextPage={nextPage} backPage={backPage} setAllowedToProgress={setAllowedToProgress} />} />
                </Routes>
            </div>
            {/* <Outlet /> */}
        </div>

    )

}



export default CreateMission;